import { generateTestId } from "@client-shared";

export const setSlaTrackerCardTestId = (identifier: string): string => generateTestId("SlaTrackerCard", identifier);
